import axios from 'axios';

let baseUrl = process.env.REACT_APP_BASE_URL

export const API_JEPX_DATA_POST = async(date) => {
    let Payload = {
        "data_date": date
    }
    let ReturnValue = {}
    try{
      await axios.post(baseUrl + `/api/jepx-spot`,
      Payload)
          .then(function (response) {
            // console.log("response",response)
            const data = response?.data?.result
            ReturnValue["data"] = data
            ReturnValue["status"] = "ok"
            ReturnValue["message"] = "データを取りました"
              
          })
          .catch(function (error) {
              if (error.response && error.response.status === 404) {
                ReturnValue["status"] = "ERROR"
                ReturnValue["message"] = error.response.data.error.reason
              } else if (error.response && error.response.status >= 500 && error.response.status < 600) {
                  // server error, handle it accordingly
                  ReturnValue["status"] = "ERROR"
                  ReturnValue["message"] = "サーバー側でエラーが発生しました。しばらくしてから再度お試しください。"
              } else if (error) {
                  // network error, handle it accordingly
                  ReturnValue["status"] = "ERROR"
                  ReturnValue["message"] = "サーバーに接続できませんでした。しばらくしてから再度お試しください。"
              } else {
                  ReturnValue["status"] = "ERROR"
                  ReturnValue["message"] = "APIサーバーに接続できませんでした。"
              }
          });
    }catch(error){
      console.log("error",error)
      ReturnValue["status"] = "ERROR"
      ReturnValue["message"] = "問題があります"
    }
    return ReturnValue
  }